import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
import "./index.scss";

import Pagination from "../../../../components/ui/Pagination";
import NoDataFound from "../../../../components/ui/NoDataFound";
import SkeletonLoader from "../../../../components/ui/SkeletonLoader";
import RadioButton from "../../../../components/ui/RadioButton";
import Button from "../../../../components/ui/Button";
import DropDown from "../../../../components/ui/DropDown";

import { useScanInfoContext } from "../../../ScanInfo/ScanInfoContext";

import { searchIcon, filterIcon } from "../../../../utils/icons";

import { useSelector, useDispatch } from 'react-redux';
import { geCERStats, getCERData, resetCERStatus, resetCERDataList } from "../../../../store/actions/scanInfoAction";

import apiEndpoints from "../../../../apiEndpoints";

const newFindingsOption = [    
    {
        label: "Yes",
        value: "yes"
    },
    {
        label: "No",
        value: "no"
    },
    {
        label: "All",
        value: "all"
    }
]

const statusOption = [    
    {
        label: "Passed",
        value: "passed"
    },
    {
        label: "Failed",
        value: "failed"
    },
    {
        label: "Warning",
        value: "warning"
    },
    {
        label: "All",
        value: "all"
    }
]

const CorporateEmailRisk = () => {

    const cerStatsResponse = useSelector((state) => state.scanInfo?.cerStats);
    const cerDataListResponse = useSelector((state) => state.scanInfo?.cerDataList);

    const dispatch = useDispatch();

    const {
        domainId,
        scanId,
        triggerListFetch,
        setTriggerListFetch,
    } = useScanInfoContext();

    const filterWrapperRef = useRef(null);

    const [activeTab, setActiveTab] = useState("dmarcChecklist");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [statsLoading, setStatsLoading] = useState(false);
    const [scanNotFound, setScanNotFound] = useState(false);
    const [cerStats, setCERStatus] = useState(null);
    const [tableDataList, setTableDataList] = useState(null);
    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    //filter value
    const [showFilter, setShowFilter] = useState(false);
    const [newFindingsType, setNewFindingsType] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    //selected filter value
    const [selectedFilterValue, setSelectedFilterValue] = useState({});

    const changeTab = (data) => {        
        setActiveTab(data);
        setSearchValue("");
        setSearchQuery("");
        setCurrentPageSize(10);
        setCurrentPage(1);
        resetFilterValue();
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }

    const applyFilter = () => {
        setCurrentPage(1);
        let obj = {
            findings: newFindingsType,
            status: selectedStatus
        }
        setSelectedFilterValue(obj)
        setShowFilter(false);
    }

    const isAnyFilterActive = Object.values(selectedFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {        
        setCurrentPage(1);
        setSelectedFilterValue({})
        setNewFindingsType("");
        setSelectedStatus("");
    }

    const fetchRecordData = useCallback(()=>{
        setStatsLoading(true)
        let url = `&domain=${domainId}&scan_id=${scanId}`
        dispatch(geCERStats(url))
    },[dispatch, domainId, scanId])

    const fetchCERdataList = useCallback(() => {
        setIsLoading(true);
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = selectedFilterValue.findings && selectedFilterValue.findings !== "all" ? `&new_record=${selectedFilterValue.findings === "yes" ? true : false}` : "";
        const status = selectedFilterValue.status && selectedFilterValue.status !== "all" ? `&status=${selectedFilterValue.status}` : "";
        const urlParams = `&domain=${domainId}&scan_id=${scanId}&page=${currentPage}&page_size=${currentPageSize}`
        let baseUrl = ""
        if(activeTab === "dmarcChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.exposureManagemnet?.corporateEmailRisk?.dmarcCheckList()}`;            
        } else if(activeTab === "spfChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.exposureManagemnet?.corporateEmailRisk?.spfCheckList()}`;
        } else if(activeTab === "dkimChecklist") {
            baseUrl = `${apiEndpoints?.scanInfo?.exposureManagemnet?.corporateEmailRisk?.dkimCheckList()}`;
        } else {
            baseUrl = `${apiEndpoints?.scanInfo?.exposureManagemnet?.corporateEmailRisk?.bimiCheckList()}`;
        }
        const url = `${baseUrl}${urlParams}${queryParams}${newFindings}${status}`;
        dispatch(getCERData(url))
    },[activeTab, domainId, scanId, currentPage, currentPageSize, searchQuery, selectedFilterValue, dispatch])

    useEffect(() => {
        fetchCERdataList();
    }, [activeTab, currentPage, currentPageSize, fetchCERdataList]);

    useEffect(() => {
        if (triggerListFetch) {
            fetchRecordData()
            setCurrentPage(1);
            setTriggerListFetch(false);
        }
    }, [triggerListFetch, currentPage, setTriggerListFetch, fetchRecordData]);

    // useEffect(()=>{
    //     if(organizationId !== prevOrganizationIdRef.current || scanId !== prevScanIdRef.current) { 
    //         fetchRecordData();
    //         setCurrentPage(1);
    //     }
    // },[organizationId, scanId, fetchRecordData, fetchCERdataList]);

    // useEffect(()=>{
    //     if(organizationId !== prevOrganizationIdRef.current) {
    //         prevOrganizationIdRef.current = organizationId;
    //     }        
    // },[organizationId])

    // useEffect(() => {
    //     if(domainId !== prevDomainIdRef.current) {
    //         prevDomainIdRef.current = domainId;
    //     }
    // }, [domainId]);

    // useEffect(()=>{
    //     if(scanId !== prevScanIdRef.current) {
    //         prevScanIdRef.current = scanId;
    //     }
    // },[scanId])

    useEffect(()=>{
        if(cerStatsResponse !== null) {
            setCERStatus(cerStatsResponse)
            setStatsLoading(false)
            dispatch(resetCERStatus())
        }
    },[cerStatsResponse, dispatch])

    useEffect(() => {
        if(cerDataListResponse !== null) {
            setTableDataList(cerDataListResponse)
            if(cerDataListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetCERDataList())
            setIsLoading(false)
        }
    },[cerDataListResponse, dispatch])

    useEffect(()=>{
        document.addEventListener("mousedown", handleClickOutside);

        function handleClickOutside(event) {
            if (filterWrapperRef.current && !filterWrapperRef.current.contains(event.target)) {
                if(showFilter){
                    setShowFilter(false)
                }
            }
        }
    },[showFilter])

    return (
        <>
            <div className="scan-info-main-content CER-main-content">
                <div className="bg-white-with-shadow p-4">
                    <div className="header-container d-flex justify-content-between align-items-center">
                        <h2>BEC</h2>
                        {/* <p>Service Provider : <span>ProofPoint</span></p> */}
                    </div>
                    <Row>
                        <Col lg={3} className="mt-2">
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"CER"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="bec-main-container p-3 h-100">
                                        <div>
                                            <h4>DMARC</h4>
                                            <p>Domain-based Message Authentication, Reporting and Conformance</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            <div className="passed text-center">
                                                <p className="count">{cerStats?.dmarc?.passed}%</p>
                                                <p className="text">Passed</p>
                                            </div>
                                            <div className="warning text-center">
                                                <p className="count">{cerStats?.dmarc?.warning}%</p>
                                                <p className="text">Warning</p>
                                            </div>
                                            <div className="failed text-center">
                                                <p className="count">{cerStats?.dmarc?.failed}%</p>
                                                <p className="text">Failed</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3} className="mt-2">
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"CER"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="bec-main-container p-3 h-100">
                                        <div>
                                            <h4>SPF</h4>
                                            <p>Sender Policy Framework</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            <div className="passed text-center">
                                                <p className="count">{cerStats?.spf?.passed}%</p>
                                                <p className="text">Passed</p>
                                            </div>
                                            <div className="warning text-center">
                                                <p className="count">{cerStats?.spf?.warning}%</p>
                                                <p className="text">Warning</p>
                                            </div>
                                            <div className="failed text-center">
                                                <p className="count">{cerStats?.spf?.failed}%</p>
                                                <p className="text">Failed</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3} className="mt-2">
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"CER"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="bec-main-container p-3 h-100">
                                        <div>
                                            <h4>DKIM</h4>
                                            <p>Domain Key Identified Mail</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            <div className="passed text-center">
                                                <p className="count">{cerStats?.dkim?.passed}%</p>
                                                <p className="text">Passed</p>
                                            </div>
                                            <div className="warning text-center">
                                                <p className="count">{cerStats?.dkim?.warning}%</p>
                                                <p className="text">Warning</p>
                                            </div>
                                            <div className="failed text-center">
                                                <p className="count">{cerStats?.dkim?.failed}%</p>
                                                <p className="text">Failed</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                        <Col lg={3} className="mt-2">
                            {
                                statsLoading ?
                                <SkeletonLoader type={"line"} count={3} currentPage={"CER"} />
                                :
                                <motion.div
                                    className="h-100"
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.4 }}
                                >
                                    <div className="bec-main-container p-3 h-100">
                                        <div>
                                            <h4>BIMI</h4>
                                            <p>Brand Indicators for Message Identification</p>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-between mt-3">
                                            <div className="passed text-center">
                                                <p className="count">{cerStats?.bimi?.passed}%</p>
                                                <p className="text">Passed</p>
                                            </div>
                                            <div className="warning text-center">
                                                <p className="count">{cerStats?.bimi?.warning}%</p>
                                                <p className="text">Warning</p>
                                            </div>
                                            <div className="failed text-center">
                                                <p className="count">{cerStats?.bimi?.failed}%</p>
                                                <p className="text">Failed</p>
                                            </div>
                                        </div>
                                    </div>
                                </motion.div>
                            }                            
                        </Col>
                    </Row>
                </div>
                <div className="mt-4">
                    <Row>
                        <Col lg={12}>
                            <div className="bg-white-with-shadow sub-domain-main-container p-3 h-100">
                                <div className="tab-container d-flex rounded">
                                    <p className={`rounded text-center ${activeTab === "dmarcChecklist" ? "active" : ""}`} onClick={()=>{changeTab('dmarcChecklist')}}>DMARC Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "spfChecklist" ? "active" : ""}`} onClick={()=>{changeTab('spfChecklist')}}>SPF Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "dkimChecklist" ? "active" : ""}`} onClick={()=>{changeTab('dkimChecklist')}}>DKIM Checklist</p>
                                    <p className={`rounded text-center ${activeTab === "bimiChecklist" ? "active" : ""}`} onClick={()=>{changeTab('bimiChecklist')}}>BIMI Checklist</p>
                                </div>
                                <div className="tab-details-content mt-3 tab-content-CER">
                                    <div className="search-header-container d-flex align-items-center gap-3">
                                        <div className="d-flex gap-3" onKeyDown={handleSearchKeyDown}>
                                            <div className="search-container position-relative">
                                                <span className="position-absolute">{searchIcon()}</span>
                                                <input type="text" 
                                                    placeholder="Search" 
                                                    value={searchValue} 
                                                    onChange={(e)=>{
                                                        setSearchValue(e.target.value)
                                                    }}
                                                    onFocus={() => setIsSearchFocused(true)}
                                                    onBlur={() => setIsSearchFocused(false)}
                                                />
                                            </div>
                                            <button className="search-btn" onClick={onSearch}>Search</button>
                                        </div>
                                        <div className="position-relative">
                                            <span className="filter-icon" onClick={()=>{setShowFilter(true)}}>{filterIcon()}</span>                        
                                            {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                                            {showFilter && <div className="filters-container position-absolute p-3 rounded" ref={filterWrapperRef}>
                                                <h6>New Findings</h6>
                                                <div className="filter-user-status d-flex mb-4 gap-4">
                                                    {
                                                        newFindingsOption.map((data,index)=>{
                                                            return (
                                                                <RadioButton radioId={data.label + index} radioValue={data.value} radioLabel={data.label} onChange={(value)=>{setNewFindingsType(value)}} key={index} isChecked={data.value === newFindingsType} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                                <h6>Status</h6>
                                                <DropDown 
                                                    placeHolder={"Status"}
                                                    options={statusOption}
                                                    isMulti={false}
                                                    isSearchable={false}
                                                    onChange={(data)=>{setSelectedStatus(data.value)}}
                                                    defaultSelectedValue={selectedStatus}
                                                />
                                                <div className="filter-apply-btn mt-3">
                                                    <Button buttonText={"Apply"}  buttonType={"primary"} disableButton={newFindingsType === "" && selectedStatus === ""} buttonClicked={()=>{applyFilter()}}/>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                    <div className="table-container mt-3 cer-data-table">
                                        {
                                            isLoading && !scanNotFound ?
                                            <SkeletonLoader type={"line"} count={5} currentPage={"CER"} />
                                            :
                                            <Table>
                                                <thead>
                                                    <tr>
                                                        <th>Name</th>
                                                        <th>Info</th>
                                                        <th>Status</th>
                                                        <th>Record</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        tableDataList?.results?.length > 0 &&
                                                        tableDataList?.results?.map((data, index) => {
                                                            return (
                                                                <motion.tr
                                                                    key={index}
                                                                    initial={{ opacity: 0, y: 20 }}
                                                                    animate={{ opacity: 1, y: 0 }}
                                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                                >
                                                                    <td>
                                                                        <p>{data?.name}</p>
                                                                        {data?.new_record && <p className="d-inline-block new-data my-2">New</p>}
                                                                    </td>
                                                                    <td>
                                                                        {data?.info}
                                                                    </td>
                                                                    <td>
                                                                        {data?.status === "passed" && <p className="passed text-center">{data?.status}</p>}
                                                                        {data?.status === "warning" && <p className="warning text-center">{data?.status}</p>}
                                                                        {data?.status === "failed" && <p className="failed text-center">{data?.status}</p>}
                                                                    </td>
                                                                    <td>
                                                                        <p className="work-break">{data?.record}</p>
                                                                    </td>
                                                                </motion.tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </Table>
                                        }
                                        
                                    </div>
                                    {
                                        !isLoading && scanNotFound &&
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={tableDataList?.description}/>
                                        </motion.div>
                                        
                                    }
                                    {
                                        !isLoading && !scanNotFound && tableDataList !== "" && tableDataList?.results?.length === 0 && 
                                        <motion.div
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.4 }}
                                        >
                                            <NoDataFound noDataText={"No Record Found"}/>
                                        </motion.div>
                                        
                                    }
                                    {tableDataList !== "" && tableDataList?.results?.length > 0 && <Pagination
                                        className="pagination-bar"
                                        currentPage={currentPage}
                                        pageSize={currentPageSize}
                                        totalCount={tableDataList?.meta?.total_results}
                                        onPageChange={setCurrentPageandRecordSize}
                                    />}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </>
        
    )
}


export default CorporateEmailRisk;